export default __webpack_public_path__ + "static/media/gray-plus.12566846.svg";